import React from 'react';
import ActionMenu from '../../../../common/action/ActionMenu';
import { MultiSelectFilterFn } from '../../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../../common/filters/MultiSelectColumnFilter';
import TextColumnFilter from '../../../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Év',
            accessor: 'year',
            id: 'year',
            show: true,
            className: 'idColumn center',
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Munkavállaló',
            accessor: 'employeeName',
            id: 'employeeName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Éves napok száma',
            accessor: 'availableDays',
            id: 'availableDays',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Áthozott napok száma',
            accessor: 'addedDays',
            id: 'addedDays',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Elhasznált napok száma',
            accessor: 'takenDays',
            id: 'takenDays',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Hátralévő napok száma',
            accessor: 'remainingDays',
            id: 'remainingDays',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Betegszabadság napok száma',
            accessor: 'sickDays',
            id: 'sickDays',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Táppénz napok száma',
            accessor: 'govPaidSickDays',
            id: 'govPaidSickDays',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Átvitt napok száma',
            accessor: 'notUsedDays',
            id: 'notUsedDays',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'availablevacation'} refresh={refresh} />,
        },

    ]
}